import type { components } from "@connect/data/frames/schema";

export type IdentityField = components["schemas"]["AvailableIdentityField"];

export interface ChipDisclosures {
  ssn: boolean;
  basicInfo: boolean;
  docs: boolean;
}

const SSN_FIELDS: IdentityField[] = ["ssn", "tin", "cpf"];
const BASIC_FIELDS: IdentityField[] = [
  "firstName",
  "lastName",
  "dateOfBirth",
  "nationality",
  "address",
  "phoneNumber",
];

export function deriveDisclosures(identity: readonly IdentityField[]): ChipDisclosures {
  const fields = new Set<IdentityField>(identity);
  return {
    ssn: SSN_FIELDS.some((f) => fields.has(f)),
    basicInfo: BASIC_FIELDS.some((f) => fields.has(f)),
    docs: identity.some((f) => f.startsWith("file.")),
  };
}
